var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "tit": "비조명 광고 솔루션",
      "bg": "/images/sub/visual/sv--product.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text line-height-15 mt-8 mt-lg-20 color-grey-c"
  }, [_vm._v(" 누구나 쉽고 안전하게 출력물 교체가 가능한 EZFLIP™ 안전개폐 프레임. 직관적으로 출력물 교체가 용이한 EZMAG™ 자석 프레임. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 설치면 돌출이 적은 로우 프로파일 디자인. 보다 경제적인 비조명 광고솔루션 제품들을 확인해 보세요. ")])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('router-link', {
    staticClass: "text-btn d-flex align-center",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow mr-8"
  }), _vm._v("Back to main")]), _c('div', {
    staticClass: "mt-12 mt-lg-20"
  }, [_c('v-row', _vm._l(_vm.programs, function (program, idx) {
    var _program$thumb;
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "h-100",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.show(program);
        }
      }
    }, [_c('card-primary', [_c('div', {
      staticClass: "thumb"
    }, [_c('div', {
      staticClass: "thumb__inner",
      style: `background-image:url('${(_program$thumb = program.thumb) === null || _program$thumb === void 0 ? void 0 : _program$thumb.url}');`
    })]), _c('div', {
      staticClass: "w-100 pa-20 pa-md-30"
    }, [_c('p', {
      staticClass: "page-text--sm color-grey-7 line-height-1 mb-2 mb-lg-6"
    }, [_vm._v(" " + _vm._s(program.subTitle) + " ")]), _c('h5', {
      staticClass: "tit-txt font-weight-bold line-height-13 word-keep-all"
    }, [_vm._v(" " + _vm._s(program.subject) + " ")]), _c('v-divider', {
      staticClass: "border-color-dark my-12 my-lg-20"
    }), _c('p', {
      staticClass: "page-text--sm line-height-13"
    }, [_vm._v(" " + _vm._s(program.content) + " ")])], 1)])], 1)]);
  }), 1)], 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }